import styles from "./ToggleSwitch.module.css";

/**
 * A pink on/off switch for a single setting. It is a real checkbox exposed as a switch, so a screen reader
 * announces its state, and it takes its name from the element named by `labelledBy`.
 *
 * @param props.checked - Whether the setting is on.
 * @param props.onChange - Called with the new state when the person flips the switch.
 * @param props.labelledBy - The id of the element that names this switch.
 * @param props.disabled - Whether the switch is disabled.
 */
export function ToggleSwitch({
  checked,
  onChange,
  labelledBy,
  disabled = false,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  labelledBy: string;
  disabled?: boolean;
}): React.JSX.Element {
  return (
    <input
      type="checkbox"
      role="switch"
      className={styles.switch}
      checked={checked}
      disabled={disabled}
      aria-labelledby={labelledBy}
      onChange={(event) => onChange(event.target.checked)}
    />
  );
}
